import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { formatText } from '../../../../helpers/value'
import { selectUserType } from '../../../../layout/store/slice'
import { USER_TYPE } from '../../../../utils/authorization'
import { selectScoreRanges } from '../../../filteredCompanies/filteredCompany/store/slice'
import { SCORE_TYPE } from '../constant'

export const CustomTdScore = ({ val, type }) => {
  const userType = useSelector(selectUserType)
  const disableNeedUpgrade = [USER_TYPE.STANDARD, USER_TYPE.LITE].includes(
    userType.userTypeId,
  )

  const scoreRange = useSelector(selectScoreRanges(type))

  const scoreRangeIndex = scoreRange.findIndex(
    (range) => val >= range.scoreRange_Min && val <= range.scoreRange_Max,
  )

  return (
    <Element className="dFlex justifyContentCenter alignItemsCenter">
      <Element
        style={{
          backgroundColor: scoreRange[scoreRangeIndex]?.color || '#BCBCBC',
          width: 40,
          textAlign: 'center',
        }}
      >
        <Element elementName="p" className="fw600" style={{ padding: '1px 0' }}>
          {disableNeedUpgrade ? (
            <Icon className="icon-lock" color="#3A414B" />
          ) : type === SCORE_TYPE.CREDIT_RISK ? (
            Number(val) === 0 ? (
              '0'
            ) : (
              formatText(val)
            )
          ) : (
            formatText(val)
          )}
        </Element>
      </Element>
    </Element>
  )
}
